export const bookingSlotsResponse: any[] = [
  {
    text: '09:00 - 09:30',
    value: {
      end: '2022-07-02T09:30+01:00',
      label: '09:00 - 09:30',
      start: '2022-07-02T09:00+01:00',
    },
  },
  {
    text: '09:30 - 10:00',
    value: {
      end: '2022-07-02T10:00+01:00',
      label: '09:30 - 10:00',
      start: '2022-07-02T09:30+01:00',
    },
  },
  {
    text: '10:00 - 10:30',
    value: {
      end: '2022-07-02T10:30+01:00',
      label: '10:00 - 10:30',
      start: '2022-07-02T10:00+01:00',
    },
  },
  {
    text: '10:30 - 11:00',
    value: {
      end: '2022-07-02T11:00+01:00',
      label: '10:30 - 11:00',
      start: '2022-07-02T10:30+01:00',
    },
  },
  {
    text: '11:00 - 11:30',
    value: {
      end: '2022-07-02T11:30+01:00',
      label: '11:00 - 11:30',
      start: '2022-07-02T11:00+01:00',
    },
  },
  {
    text: '11:30 - 12:00',
    value: {
      end: '2022-07-02T12:00+01:00',
      label: '11:30 - 12:00',
      start: '2022-07-02T11:30+01:00',
    },
  },
  {
    text: '13:00 - 13:30',
    value: {
      end: '2022-07-02T13:30+01:00',
      label: '13:00 - 13:30',
      start: '2022-07-02T13:00+01:00',
    },
  },
  {
    text: '13:30 - 14:00',
    value: {
      end: '2022-07-02T14:00+01:00',
      label: '13:30 - 14:00',
      start: '2022-07-02T13:30+01:00',
    },
  },
  {
    text: '14:00 - 14:30',
    value: {
      end: '2022-07-02T14:30+01:00',
      label: '14:00 - 14:30',
      start: '2022-07-02T14:00+01:00',
    },
  },
];

export const testMockData = {
  getBookingSlots: [
    {
      start: '2022-07-02T09:00+01:00',
      end: '2022-07-02T09:30+01:00',
    },
    {
      start: '2022-07-02T09:30+01:00',
      end: '2022-07-02T10:00+01:00',
    },
    {
      start: '2022-07-02T10:00+01:00',
      end: '2022-07-02T10:30+01:00',
    },
    {
      start: '2022-07-02T10:30+01:00',
      end: '2022-07-02T11:00+01:00',
    },
    {
      start: '2022-07-02T11:00+01:00',
      end: '2022-07-02T11:30+01:00',
    },
    {
      start: '2022-07-02T11:30+01:00',
      end: '2022-07-02T12:00+01:00',
    },
    {
      start: '2022-07-02T13:00+01:00',
      end: '2022-07-02T13:30+01:00',
    },
    {
      start: '2022-07-02T13:30+01:00',
      end: '2022-07-02T14:00+01:00',
    },
    {
      start: '2022-07-02T14:00+01:00',
      end: '2022-07-02T14:30+01:00',
    },
  ],
};

const date = new Date();
export const requestSlotsResponse: any[] = [];
